<template>
    <!-- -->
  
    <div class="distributed">
      <Head :index="'3'"></Head>
      <div class="chartTop">
        <div class="fl">
          <el-button @click="tabClass('table')" :class="{ active: type == 'table' }" type="text" size="big">列表
          </el-button>
          <el-button @click="tabClass('map')" :class="{ active: type == 'map' }" type="text" size="big">地图</el-button>
        </div>
        <div class="fr"></div>
      </div>
      <div v-if="type == 'table'" style="width: 100%;height:100%">
        <el-table :data="familyareaData" border style="width: 822px;height:calc(100% - 115px)">
          <el-table-column prop="xm" label="姓名" width="100"></el-table-column>
          <el-table-column prop="shixu" label="世序" width="100"></el-table-column>
          <el-table-column prop="czsheng" label="省" width="100"></el-table-column>
          <el-table-column prop="czshi" label="市" width="100"></el-table-column>
          <el-table-column prop="czxian" label="县/区" width="100"></el-table-column>
          <el-table-column prop="czzhen" label="村" width="250"></el-table-column>
        </el-table>
      </div>
      <div v-else class="amap-page-container">
        <el-amap :show-label="true" :center="center" :zoom="zoom" @click="clickMap" @init="initMap">
          <el-amap-marker
            v-for="(marker, index) in points"
            :key="index"
            :position="marker.lnglat"
            :icon="(marker.type == 1 ? img1 : (marker.type == 2 ? img2 : (marker.type == 3 ? img3 : (marker.type == 4 ? img4: img5 ))))"
            @click="clieckXm(marker)"
            @mouseover="mouseoverXm(index)"
            @mouseout="mouseoutXm(index)"
          >
          </el-amap-marker>
          <div v-if="points">
            <el-amap-info-window
              v-for="(item, index) in points"
              :is-custom="true"
              :key="'win' + index"
              :position="item.lnglat"
              :visible.sync="item.visible"
              :offset="[20, 80]"
            >
              <div :class="{infoXm:item.visible}">
                <p>{{ item.intro }}</p>
                <p>{{ item.peintro }}</p>
              </div>
            </el-amap-info-window>
          </div>
        </el-amap>
      </div>
  
      <ul class="ry" v-show="liData.length != 0">
        <li v-for="(item, index) in liData" :key="index">{{ item.xm }} {{ item.czsheng }} {{ item.czshi }} {{
            item.czxian
          }}
        </li>
      </ul>
  
      <el-dialog :visible.sync="infoDialog" :title="title" width="300px">
        <div class="con" v-html="content"></div>
      </el-dialog>
    </div>
  
  
  </template>
  
  <script>
  import {defineComponent} from "vue";
  import api from "@/request/api";
  import Head from "@/components/header.vue";
  
  export default defineComponent({
    name: "Map",
    data() {
      return {
        title: "",
        content: "",
        infoDialog: false,
        center: [104.937478, 35.439575],
        zoom: 3,
        points: [],
        areapoints:[],
        visible: true,
        type: "map",
        liData: [],
        data: [],
        familyareaData: [],
        img1:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAcCAYAAAC3f0UFAAABrUlEQVQ4jc1TsYoUQRB9r3pOEW+TFXbhQM4vuAU/xMQv0MDAE/Gy+woxES5eFX/ADzARMTQ5NDt1EeQQg1NXdrbrSY3Ty7gMumYWDF3d9aqm36tq/ItxMpk0cEmoqgruvlfX9T6A5wCedmtVxSGJnPMld39BclvSLTOzlNKTKBRmOecARcVYb0raLsmS7pZYfFXJig2AEzNb/VbSScQjMSyNx+PVRtKxmb0GsAtgCuB2xEqBNBqNYj1H8iCldANABnAK4DPJ6wCuAXgD4EsQ3ALwEsDVcqV1k7RPcs9I3gvg3+SWdGjufqXdzwD86MHN2nXHCjkAjyR97AFPS0+CZrlo+OwBFy1lPcF143rWRmadhN7EjpxNa6IJ0e7VaZDuEC/niqY8JnkewDMABwFy9+jYZZIXAbwFcAfAWUzhqxhHd39HciulhPl8flTX9Yd2Ji5IekhyWi2XS/S0OXU5RLwZ0ZjXX7f/szDNS+qM50bSbWz/G5jkys85WyEsqfEbNTrSfGuBGAwGp5Lq9mV//e11h8Zm9p3ke3c/Hg6H993902KxmKWUHphZNjP8BKv70hKAxqSaAAAAAElFTkSuQmCC",
        img2:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAcCAYAAABh2p9gAAAD+0lEQVRIiZVVPWxcRRD+Znb33S9nG5sTEU6UQ4QAHTQ0EAQ1EhUSkRCiggYKRIcigURHUgISBQVKGhMkEDFFinQERfzIBRBiOwqKETrjX+Lc3Tvf292Jdn3vZJy7A0bap93Z2W++nZ991Gg0EISZkWUZNZvND6y1z5XL5Tdrtdp3zb8znHpyAu+fmERnx0P5XrnQa50FcdLsuFe3e7JpGAPRGxsbA8Ber3c6y7K3w7rb7V4WkUeRumt/rDmgKyinDiCaB+hZQDBT4C+L7E8w7QNM0zSCee/hnDselEQU5kH3EGCukVIAMYQF5P1xEAU8GE1Hp4wCvAwAuVgswhiDWq2GarV6LihFBFrrxXq9Pg+lkPUygBUcGJb1Z/EkATu7fm69HR0DbCCmCm2tjWwCcKVSmWPmb621jUKh8H086D18oEMCJR6W1DsAXYSI1oRLiSEwBAKCEEMrpYKH11ut1klm7jDzMoBb3W73tU6ncxiSrVlUPgbwIkFeMpL9BdD14Kps6EMACbxcBfCWANepVCq92+123wvXHCX3Vwz+fPkBcEJANswu3EAteE6e4DRNjwWVUmopJGP/YOZdkLq52nb4veXXoWllCNqqgFYh7nHYtMjMfE84LCIX/uFTJAB2VJJcDgwc6AZAy0O4bQrwTcgSEU1zfnjYlYMuZjCUA1EGwtRBGwLVvVAanZI6zHehjBCBdCAwQ3ZnQLAxjMAhHpeMAYnIFh0Albu3hTRQDsXO4o/8K2C+yxQAZWK4jdwXv0QNHRIyVpzokkZvuoB1eEyPcBpCsQPg2CCGI4EVF1MrN9NMWhhhIiAtoA2Gn9QTExOfttvt8yIyFdowr0PErvNTlJhLJYWPEsbTGB2dWQc6ySK32RjztXPuXADD3jO2pLV+Iy8l2cWV00/de3Gmbo5g1w9FI+BBL/jVA7/x9vZ2rLWcFTOnAH7KjctVlb7wyCSQ4RmMSCBDykrkUBYenfyao2SmSLZuQg/7nxEzHWURwI/9eQ/AsmYUCxwbYFyWCSubtjZ3dQso4XmAzvY3Pgdwpj9fAsnDIPkl3H1sp8Sn3QNzNxzgKfYZ9lTk+2dDEDLP/UHQ4wBjxFQIX6zHAWA7o8eYsF0xHtZxvWlV8B1cjgfMRXMsVORJ8UBhX19rJ6T+F+BBKTEckXgIQZH4aeUkz8R/B6Q4ONBLlOytJAaSatoNMqsPPg7713tzAoUIWYE4ifOgDiWu+nZ+wC/WMcf/MjNHJGZ2SikXSYW4sexupQ63O0DqeT4w9YIrqcX5PsaCCGUiwRFBJ0mSs/nCOfcKgE+MMT9Yay8Q0UoGu7C4Jbhlq5it8Ffi6agiv6ZIUkdqVkF2VN7kAO4AQifmlus8qc8AAAAASUVORK5CYII=",
        img3:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAcCAYAAABVo158AAAD50lEQVQ4jWVUSWwcRRR9tXT39KztsZ3xeEtsgkGOMYjFWJiwJFEuCCniEIkLJyROSNy4Ei5wgUMkOHAlB4QEBiRAICESCzAKXmQUHCf2GMfRJB5vY89MT89Ud1WhGsCQ5JdKqsN79X/9936RYO0KTBBuQVEO9cm5E4n12Y9KTRL9NPLKa72nX74U93cgtW7heHS7YODQTgK0ttsdX/31G2wsO7kYxcTsBxe/IKmjPNNeoKIOQIOH61cBbkOnOmCvzeXIbtFBWy/gUiS2N7Fwebon6DhSIH4ZSmtwO+WBlgrQlQ3UH31xHvX9z5Pzky+hofFDz5mvx8bPTrX7tzASUXjpNDhzU2CUohmG4OUiWNg4G2QHXl/0LZbl6vwDP7+HqUPP4WSPQEKVwJ22Tsgim3BnvvqYzk1myF5pRXo91x+2Kfjmt780Qp5PCL+uneE3MXp8ki9tVnB4eeat+M2rA8i0A15+jCkxBgXA7kDMCtG/fRla7VyoDY0P0OWVVRcbhcfR1Y8o2dGEFKZrurWVhKQx0eg8FpBgL15emBqhfY1iPi7rXiPVVZKx1BZkhIPQCorbtZ1EfglSwrGtbpr1N7oNSIOUWdRwQPl/BEJhRY2kVqGOuItkpdhD7ZTXBy2hqRUwGVog5H8EoiGFDQ0dEoaYDvOUl4uDoAxaS0FkmDaq3xEqAocmktogUvZTR1QHwR1zXQgpaOvWu8LWIQUUiBR9NCab9wtqI2IOgQrvxhr7wDKdY1YFot5HrdrtcaFkKZKS3Iv+m0EYZ9pJVFAu5vj2odF39gPhZxGcMfXei9dghMRFe+8kYixDLl34EJWtW8nnVz67mWjueODxO9+gQhISGzfuO3Esl21bpHXfR8pmeVcGHgg/KAPQ5EAL1cSetvIzfgz0yaefwWNZepxuraGlshFOKSAKW+DWVk20i72jtuuCvftgDVtLv5O17PD1XNoZxe5a6kZ66Psd78hv2eqfDzW1HUSNxrlgaOLLaPCJMtWFBQgrMVc+/cb7It1dRlAFHHeJeblZY8SmJuEfYfp8aXd/1V+/Bn7thbfBbQf5mA3hV7UNwIGE1JFxLFwGWG4cWLyI1JXvwKNkJyJCIK24+TnqZg4szrWynBBKgwLI8RBgDES74Ez40MZLjJuec2MlZR6tJDVn0y9hhgmktXgYz7YIkZuBZlYVErAtrqQda5oMjGh0cnkgC5epDmjKIeOeIQhDoIxpWI40KhNoxGCm8B+C2lhtZZCxNFSwT0zRqlqGdLZNBUAzIOpffcxHloxqZlAgbAuBd/jHDMVJ+sipeeF2TWP+U4TDT03vPftqlYYBoCT+AoYP0XPDaXAnAAAAAElFTkSuQmCC",
        img4:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAcCAYAAAC6YTVCAAABZElEQVQ4jcWTvy9EQRDHP3eeROS0BB2nEY1EREFC5BR+JRcJlQL3Nyg0av4WzQmiExQIBYUoKEQjKgkScXF5snw32Vv7PNGYZDJvZuezOzP7lr9IJiYXwkaARaAMbHxbNZCnhZhc7GjJz8kGTpnx/Hk/IQRdev6Fn5DU0wJQAjaBtbSTJpXYC1wBrfKXarKcBme9Afi6YnPd8k6Bvs99IFOz75f/ALQDVVtep4AjYM8r+RjYBlqAYbenMdkDoN6DTPKJvqdcqChbBYY8qANoBF6ACQuZQAE4g/D8gWZgF8gD3VkBdhD5BKgHuLWtGGhUzqOGEZJ+4E3x8QjYF/CuMpKkCVgGKu49HQKDP0A3QJc7vbYUAPU74ELTKYCVoguZW5/Tjd8pVpZ91qWad7ZjApEWzqVGnmSvZc3UttzjQo+wTjZKyglBqfK/kI3Z3n4FVWRfkyA7IVfWzU8JrAINwH3NKvABZeZgJ2EUDj8AAAAASUVORK5CYII=",
        img5:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAcCAYAAACDBoQZAAADMklEQVRIiaWVQYhWVRTHf+d+b8bvU0cbnYp0Rhl1Z5ZQohYmDUi1CyJcJFQiLioiyIUo7UKXIS5qE+imhbgqMSEmQXJRSERS4SJL+lKH0UxnmHGc970T537nju/7eslAf3i8e+4973/PPed/zxOlAzXgENACDgJx+Y23jnH8tdehGc2HgAPAHeDD8sdZaWxE3wJPub0d2AYUJZ8+4GfgMbfN95XkE0qOq0tEhmfSR735PZA4t7VEZHgZWJmMMtl14HbJHgdu2GCqd6EfmIudWeGS+0WIivhIoIjRHvSwD5vRXD7E8CeXyXszuBsZ68D7tgfw0b9zFoKRraAongS+8wK8Cvw4UV98KV+UBabY5UdsAj95cfYC/cBvwKkMVWjZtzGxS7uOweCtP5c1bk1vmu5rHGe6e7UD+0MuQktkXRWRoW/qzrtrrl9excJozlS43PX3QJit1ShERnziSvJQkRsKY8CLw+O/P04vN4EzFWSngUmgEXqKgkz1BSe40LXjWWDT6vErm8kiWV5BZsXqscIEUUVUd2gI35c1JKqDKmJSudY/+dcWalE2WQXZjM8PhZrqckuNivwgsLbsFVSN4JvmskGLyaKSCrKb/iwIsyLbPJJ+VB/tctxgwi1C1LaJ+u8KsuCbFEHgnRiq6pIKx+1RzqrpOFU5k0QYMtgIXBUYqHA0QUzcq8VUPZG6SBdsA0vVqizPsvVZnj8HfFbhaMgmG4vfpMFaWqyJvYU5+TY84p02FySEMQ2hjmpVpQw73/vy6LFsLP+AerrI8W7u8/Ei4ATwRQitliV/z38QGYZGLo4O7xj9Ch5udxG/5FM+nut3QfLcusWAhz7rz4SvX/P5pwcnmqamHp+v+9OBoG1qa3omC7sBfwBH3OlZ4BG7Rl+vf77dqB+AlKfk1vJSt9y2Sk1+OrKbXzevazeaKtmmSknnes3NdByrFmc2vuSiqFLGfYQHribGmen7Mf9fsqDFPLzmSTZfdAt1gT+p7Cl3CfYDNtj/s30XStdwLjJPrdm2QdJZeidYzzP8Yq3JO+xoWsyKuRsS9faxqC4ROKcwIDDWlfOTvtl53+ht4PO4AvwDszLwuRvoajQAAAAASUVORK5CYII=",
      };
    },
    created() {
      let that = this;
      api.familyGet(localStorage.getItem("fid")).then((res) => {
        // console.log(this.center,'----center');
        // console.log(res.data.coordinate,'----res.data.coordinate');
        if (res.data.coordinate == "") {
        //   this.center = [0, 0];// 中心点坐标
          this.center = [116.367827, 40.0865];
        } else {
          this.center = res.data.coordinate.split(", ");
          // basePosition.push([this.center[0], this.center[1], res.data.num, ""]);
          this.data.push({lnglat: [this.center[0], this.center[1]], weight: 1});
        }
        // console.log(this.data,'----this.data');

      });
      //
      // api.getancestorarea(localStorage.getItem("fid")).then((res) => {});
      api.familyarea(localStorage.getItem("fid")).then((res) => {
        this.familyareaData = res.data;
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].hascoordinate) {
            this.data.push({
              id: res.data[i].id,
              lnglat: res.data[i].czdtdz.split(","),
              sex: res.data[i].sex,
              weight: 1,
              xm: res.data[i].xm,
              age: res.data[i].age,
              shixu: res.data[i].shixu,
              pexm: res.data[i].pexm,
              intro:res.data[i].intro,
              peintro:res.data[i].peintro,
              type:res.data[i].type,
              visible: false
            });
          }
        }
        that.$nextTick(() => {
          that.points = this.data;
        //   console.log(this.data,'---pointsdatadatadata');
        });
      
      });
    },
    methods: {
      toChies(num) {
        var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿'];//可继续追加更高位转换值
        if (!num || isNaN(num)) {
          return "零";
        }
        var english = num.toString().split("")
        var result = "";
        for (var i = 0; i < english.length; i++) {
          var des_i = english.length - 1 - i;//倒序排列设值
          result = arr2[i] + result;
          var arr1_index = english[des_i];
          result = arr1[arr1_index] + result;
        }
        //将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十');
        //合并中间多个零为一个零
        result = result.replace(/零+/g, '零');
        //将【零亿】换成【亿】【零万】换成【万】
        result = result.replace(/零亿/g, '亿').replace(/零万/g, '万');
        //将【亿万】换成【亿】
        result = result.replace(/亿万/g, '亿');
        //移除末尾的零
        result = result.replace(/零+$/, '')
        //将【零一十】换成【零十】
        //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
        //将【一十】换成【十】
        result = result.replace(/^一十/g, '十');
        return result;
      },
      aa(e) {
        return {
          count: 100
        };
      },
      tabClass(val) {
        this.type = val;
      },
      clickMap(e) {
        console.log("click map: ", e);
      },
      initMap(map) {
        console.log("init map: ", map);
      },
      clieckXm(marker) {
        api.memberGetinfo(this.$qs.stringify({mid: marker.id, num: 1})).then((res) => {
          if (res.code == 0) {
            var html = "";
            var title = "";
            for (let i in res.data) {
              title += res.data[i].name + "（" + this.toChies(res.data[i].shixu) + "世）";
              html += "<h3><p>" + res.data[i].info.replace("\n", "</p><p>") + "</p><h3>";
            }
            this.title = title;
            this.content = html;
            this.infoDialog = true
          }
        });
      },
      mouseoverXm(ind) {
        let that = this;
        that.$nextTick(() => {
          that.points[ind].visible = true;
        });
      },
      mouseoutXm(ind) {
        let that = this;
        that.$nextTick(() => {
          that.points[ind].visible = false;
        });
      },
      changeVisible() {
        this.visible = !this.visible;
      },
      markerInit(e) {
        console.log("marker init: ", e);
      },
      clickMarker(e) {
        console.log("marker click: ", e);
        this.liData = e.clusterData;
      },
      _renderCluserMarker(context) {
        console.log(context,'-----context');
        const count = this.markers.length;
        let factor = Math.pow(context.count / count, 1 / 18);
        let div = document.createElement("div");
        let Hue = 180 - factor * 180;
        let bgColor = "hsla(" + Hue + ",100%,50%,0.7)";
        let fontColor = "hsla(" + Hue + ",100%,20%,1)";
        let borderColor = "hsla(" + Hue + ",100%,40%,1)";
        let shadowColor = "hsla(" + Hue + ",100%,50%,1)";
        div.style.backgroundColor = bgColor;
        let size = Math.round(30 + Math.pow(context.count / count, 1 / 5) * 20);
        div.style.width = div.style.height = size + "px";
        div.style.border = "solid 1px " + borderColor;
        div.style.borderRadius = size / 2 + "px";
        div.style.boxShadow = "0 0 1px " + shadowColor;
        div.innerHTML = context.count;
        div.style.lineHeight = size + "px";
        div.style.color = fontColor;
        div.style.fontSize = "14px";
        div.style.textAlign = "center";
        console.log(size,'------size');
        console.log(div,'------div');

        context.marker.setOffset(new AMap.Pixel(-size / 2, -size / 2));
        context.marker.setContent(div);
      }
    },
    components: {
      Head
    }
  });
  </script>
  
  <style lang="less" scoped>
  .infoXm {
    background: #fff;
    border: 1px solid #888;
    padding: 5px 20px;
    border-radius: 5px;
  }
  
  .distributed {
    width: 100%;
    height: 100%;
    overflow: hidden;
  
    .chartTop {
      height: 55px;
      line-height: 55px;
      padding-right: 20px;
      padding-left: 10px;
      .active {
        color: #ff0000;
      }
  
      button {
        color: #000;
      }
    }
  
    /deep/ .el-dialog__title {
      font-weight: bold;
      padding: 15px 0 15px 0;
    }
  
    /deep/ .el-dialog__body {
      padding: 0px 15px 15px 15px;
    }
  
    /deep/ .con {
      h3 {
        font-size: 15px;
        line-height: 23px;
      }
    }
  
    /deep/ .el-table {
      .el-table__body-wrapper {
        overflow: auto;
        width: 100%;
        height: 100%;
      }
  
      border: 1px solid #000;
    }
  
    /deep/ td.el-table__cell,
    /deep/ th.el-table__cell.is-leaf {
      border-bottom: 1px solid #000000 !important;
    }
  
    /deep/ .el-table--border .el-table__cell {
      border-right: 1px solid #000 !important;
    }
  
    /deep/ .el-table--border,
    /deep/ .el-table--group {
      border: 1px solid #000000 !important;
    }
  
    .amap-page-container {
      width: 100%;
      height: 100%;
      // height: calc(100% - 115px);
      .search-box {
        position: absolute;
        top: 25px;
        left: 20px;
      }
  
      .amap-div {
        width: 100%;
        height: 100%;
        position: relative;
      }
    }
  
    .ry {
      width: 375px;
      overflow-y: hidden;
      background: #fff;
      max-height: calc(100vh - 120px);
      box-shadow: 0 0 8px 0 #a2a2a2;
      border-radius: 4px;
      position: absolute;
      top: 88px;
      left: 24px;
      padding: 16px;
      z-index: 9;
      overflow: auto;
    }
  
    // .fl {
    //   padding-left: 20px;
    // }
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/mobile/distributed.vue